// Start the mocking conditionally.

if (window._env_.REACT_APP_MOCK_BACKEN_API === true) {
    const { worker } = require('./browser')
    worker.start()
  }
  